import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "user-info" }
const _hoisted_2 = { class: "user-info-name" }
const _hoisted_3 = {
  key: 0,
  class: "balance"
}
const _hoisted_4 = { class: "balance" }

import store from '@/store'
import { computed } from 'vue'
import { can } from '@/helpers/utils'
import { formatUsdt, formatRub } from '@/helpers/format'


export default /*#__PURE__*/_defineComponent({
  __name: 'UserInfo',
  setup(__props) {


const balanceFormatted = computed(() => formatUsdt(store.state.balance))
const name = computed(() => store.state.user?.name)
const rates = computed(() => store.state.rates)

return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(name.value), 1),
    _createElementVNode("div", null, [
      (_unref(can)('USDT_ACCOUNT'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(balanceFormatted.value), 1))
        : _createCommentVNode("", true),
      (_unref(can)('USDT_ACCOUNT') && rates.value.UsdtToRub)
        ? (_openBlock(), _createBlock(_component_el_tooltip, {
            key: 1,
            placement: "bottom"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(formatRub)(_unref(store).state.balance / 1000000 * 1.03 * parseFloat(rates.value.UsdtToRub))), 1)
            ]),
            content: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(formatRub)(_unref(store).state.balance / 1000000 * parseFloat(rates.value.UsdtToRub))) + " + 3% ", 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})